module.exports = __webpack_public_path__ + "media/packs/images/sea-5042ace7683213ff0b66eeb71319098a.svg";